/**
 * Utility function to get the proper URL for a store logo
 * Uses the /api/files endpoint which works for both store-specific and platform admin contexts
 */
export const getLogoUrl = (logo?: string, fallback: string = "/logo512.png"): string => {
  if (!logo || logo.trim() === "") return fallback;
  if (logo.startsWith("http://") || logo.startsWith("https://")) {
    return logo;
  }

  // Use API endpoint to serve files from static directory
  // Get backend URL dynamically based on current hostname
  const getBackendUrl = (): string => {
    if (process.env.REACT_APP_BACKEND_BASE_URL && process.env.REACT_APP_BACKEND_BASE_URL !== "/") {
      return process.env.REACT_APP_BACKEND_BASE_URL;
    }
    if (typeof window !== "undefined") {
      const hostname = window.location.hostname;
      if (hostname.includes("localhost") || hostname.includes("local")) {
        return `http://${hostname}:5100`;
      }
      return `${window.location.protocol}//${hostname}`;
    }
    return "http://localhost:5100";
  };

  const backendUrl = getBackendUrl();
  // Remove leading slash if present, then construct API endpoint URL
  const cleanPath = logo.startsWith("/") ? logo.slice(1) : logo;
  return `${backendUrl}/api/files/${cleanPath}`;
};





